var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0004 49.0237C23.3742 49.024 21.7521 48.8605 20.1588 48.5354C17.0858 47.9061 14.1669 46.6779 11.5684 44.9207C7.70599 42.3135 4.6826 38.642 2.86465 34.3512C2.25014 32.8979 1.78118 31.3874 1.46465 29.8417C0.813866 26.6468 0.813866 23.3535 1.46465 20.1587C2.09424 17.0858 3.3225 14.1669 5.07946 11.5684C7.68679 7.7059 11.3584 4.68249 15.6492 2.86445C17.1025 2.25014 18.6131 1.78125 20.1588 1.46465C23.3536 0.813866 26.6469 0.813866 29.8418 1.46465C32.9147 2.09404 35.8336 3.32228 38.4319 5.07936C42.2943 7.68681 45.3176 11.3584 47.1357 15.6492C47.75 17.1025 48.219 18.613 48.5357 20.1587C49.1863 23.3536 49.1863 26.6468 48.5357 29.8417C47.9062 32.9146 46.6779 35.8335 44.9207 38.4318C42.3135 42.2943 38.642 45.3177 34.3512 47.1356C32.8979 47.7499 31.3874 48.2188 29.8418 48.5354C28.2485 48.8605 26.6265 49.024 25.0004 49.0237ZM25.2594 26.7571L33.4051 34.9032L35.216 33.0924L27.0699 24.9468L35.216 16.8011L33.4051 14.9913L25.2594 23.1364L17.1139 14.9913L15.304 16.8011L23.4495 24.9468L15.304 33.0924L17.1139 34.9032L25.2594 26.7571Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithWhiteCircle);
export default __webpack_public_path__ + "static/media/close_with_white_circle.b2abf0032ead4da3bc28250c520664fd.svg";
export { ForwardRef as ReactComponent };